import React from 'react';
import { Clock, AlertTriangle, Download } from 'lucide-react';
import { Button } from '../ui/button';
import { useLanguage } from '../../context/LanguageContext';
import { AccountLink } from './AccountLink';

export const AwaitingUTT = ({ application, onEdit, onLinkAccount, onDownload }) => {
  const { t } = useLanguage();
  const needsInfo = application?.status === 'needs_info';
  return (
    <div className="space-y-4" data-testid="utt-awaiting">
      <div className={`flex items-start gap-3 rounded-2xl border p-4 ${needsInfo ? 'border-amber-300 bg-amber-50' : 'border-primary/30 bg-primary/5'}`}>
        {needsInfo ? <AlertTriangle className="mt-0.5 h-5 w-5 text-amber-600" /> : <Clock className="mt-0.5 h-5 w-5 text-primary" />}
        <div className="flex-1 text-sm">
          <p className="font-semibold" data-testid="utt-awaiting-status">
            {needsInfo ? t('UTT AMIS needs more information', 'UTT AMIS inahitaji taarifa zaidi')
                       : t('Application sent to UTT AMIS', 'Ombi limetumwa UTT AMIS')}
          </p>
          <p className="mt-1 text-muted-foreground">
            {needsInfo ? application.needs_info_reason
              : t('We are processing your UTT AMIS account. You will receive your account number via SMS within 24–48 hours (we will also message you on WhatsApp).',
                  'Tunashughulikia akaunti yako ya UTT AMIS. Utapokea namba yako ya akaunti kwa SMS ndani ya saa 24–48 (tutakutumia pia WhatsApp).')}
          </p>
          <p className="mt-2 text-xs text-muted-foreground" data-testid="utt-application-ref">
            {t('Reference', 'Kumbukumbu')}: <b>{application?.ref}</b> · {new Date(application?.submitted_at).toLocaleString()}
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button variant={needsInfo ? 'default' : 'outline'} onClick={onEdit} data-testid="utt-application-edit">
          {needsInfo ? t('Update my details', 'Sasisha taarifa zangu') : t('Edit my application', 'Hariri ombi langu')}
        </Button>
        <Button variant="ghost" onClick={onDownload} data-testid="utt-download-form">
          <Download className="mr-2 h-4 w-4" />{t('Download my completed form', 'Pakua fomu yangu iliyojazwa')}
        </Button>
      </div>
      <details className="text-sm">
        <summary className="cursor-pointer text-muted-foreground" data-testid="utt-have-account-toggle">
          {t('Already have a UTT AMIS account number?', 'Tayari una namba ya akaunti ya UTT AMIS?')}
        </summary>
        <div className="mt-3"><AccountLink masked={null} onSave={onLinkAccount} /></div>
      </details>
    </div>
  );
};
